import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { debounceTime } from "rxjs/operators";
import { Subject } from "rxjs";
import { SelectItem } from 'primeng/api';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { ComencdevfacService } from '../../com/comservicios/comencdevfac.service';
import { DatePipe } from '@angular/common';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { CalculosServiceService } from '../../servicios/calculos-service.service';
import { VenenguiaRemisionService } from "../../ven/venservicios/venenguia-remision.service";//CDPJ
import { isNullOrUndefined } from 'util';


@Component({
  selector: 'app-busdlgartpet',
  templateUrl: './busdlgartpet.component.html',
  styleUrls: ['./busdlgartpet.component.css']
})
export class BusdlgartpetComponent implements OnInit, OnChanges {
  filtros: any = {}
  filtro$ = new Subject<string>();
  @Input() arregloConsulta: any[];
  @Input() arrayOptions: SelectItem[];
  @Input() tabla: string;
  @Input() busquedaParams: string[];
  @Input() consulta: string;
  @Input() where: string;
  @Input() busquedaCompuesta: boolean;
  @Input() existencias: string;//CDPJ
  @Input() precioarticulo: string;//CDPJ
  @Input() descuentoarticulo: string;//CDPJ
  @Input() DVBUSGR: Number;//CDPJ
  @Input() heightguia
  @Input() heightguiascrol
  @Input() bodega
  @Input() tipobus
  @Output() opcionSeleccionada = new EventEmitter<any>();

  tipoBusqueda: string;
  tipoSeleccionado: string;
  spin: boolean;
  maestro: string;
  constructor(private busqService: InvbusquedaService, private datePipe: DatePipe,
    private comdevService: ComencdevfacService, private calc: CalculosServiceService,
    public init: NuevoComponentService, public guiaservicio: VenenguiaRemisionService) { }

  ngOnChanges(changes: SimpleChanges): void {
    for (const valor in changes) {
      if (valor === 'arrayOptions') {
        //console.log('dlg3',this.arrayOptions)
        if (this.arrayOptions !== undefined) {
          this.tipoSeleccionado = this.arrayOptions[0].value;
          this.filtros={}
        }
      } else if (valor === 'arregloConsulta') {
        //console.log('dlg4')
      }
    }
  }

  ngOnInit(): void {
    this.filtro$.pipe(debounceTime(300))
      .subscribe(valor => {
        this.buscar(valor)
      })
  }
  onfiltrochange(campo, valor) {
    this.filtros[campo] = valor;
    this.filtro$.next(this.filtros)
  }
  async buscar(filtros) {
    try {
      if (this.tipobus === 'artcod') {
        const datos = await this.busqService.buscarartgre(filtros, this.bodega)
        this.arregloConsulta = datos
      }else if (this.tipobus === 'encgre') {
        const datos = await this.busqService.buscarencgre(filtros)
        if (datos !== null ) {
          for (const iterator of datos) {
            if (isNullOrUndefined(iterator.ENCGRE_FECHAEMISION) === false) {
              if (iterator.ENCGRE_FECHAEMISION.toString().includes('-')) {
                iterator.ENCGRE_FECHAEMISION=this.datePipe.transform(iterator.ENCGRE_FECHAEMISION,'dd/MM/yyyy')
              }
            }
          }
        }
        this.arregloConsulta = datos
      }else if (this.tipobus === 'vendedor') {
        const datos = await this.busqService.buscarvendedor(filtros)
        this.arregloConsulta = datos
      }else if (this.tipobus === 'clientes') {
        const datos = await this.busqService.buscarclientes(filtros)
        this.arregloConsulta = datos
      }

    } catch (error) {
      console.log(error)
    }
  }
  recargar() {
    for (let i = 0; i < 30; i++) {
      this.busquedaParams[i] = '';
    }
    this.tipoBusqueda = 'contains';
    this.guiaservicio.tipofiltrobus = '';//CDPJ
    this.busquedaIndi(this.busquedaParams, this.tipoBusqueda);
  }
  busquedaIndi(params, tipo) {

  }
  async abrirpestanamaestro() { }
  prueba() {
    document.getElementById('tr').focus();
  }
  selectedOption(opcion) {
    for (let i = 0; i < 30; i++) {
      this.busquedaParams[i] = '';
    }
    this.opcionSeleccionada.emit(opcion);
  }
}
